export default __webpack_public_path__ + "static/media/indimg9.93fa8a5b.webp";